import { CASINO_IMGIX, CDN_IMG_URL } from "../cdn";
import bitcasino from "./bitcasino";

const livecasino: SiteConfig = {
  ...bitcasino,
  name: "Livecasino",
  handle: "livecasino",
  languages: ["en", "ja", "ko", "vi"],
  domain: "livecasino.io",
  csEmail: "cs@livecasino.io",
  iconSetCdnPath: `${CDN_IMG_URL}/icons`,
  iconSetExt: ".svg",
  defaultColorScheme: "dark",
  refCode: "lcseo",
  fontTypes: ["Averta Std"],
  blogCategories: ["live-dealer", "casino-tips", "slots", "cryptocurrency"],
  privacyPolicyLink:
    "/help-center/help-terms-and-conditions/livecasino-privacy-policy",
  termsAndConditionsLink:
    "/help-center/help-terms-and-conditions/terms-and-conditions",
  registerButtonText: "loyalty_landing.play-get-rewards",
  fullstoryAccountId: "15XWZB",
  optimoveConfig: undefined,
  menuItemsConfig: {
    common: {
      first: 4,
      filterName: "^(?!(live|bombay).*$)",
    },
    live: {
      first: 4,
      filterName: "^live",
    },
  },
  protoConfig: {
    gwId: "gw_3LWVDxIVZ2xpQBTQqUhyvVL",
  },
  convertComConfig: {
    isScriptEnabled: false,
    url: "",
  },
  icons: {
    icon: [
      {
        url: `https://${CASINO_IMGIX}/bitcasino/images/livecasino/favicon/favicon-32x32.png`,
        sizes: "32x32",
        type: "image/png",
      },
      {
        url: `https://${CASINO_IMGIX}/bitcasino/images/livecasino/favicon/favicon-16x16.png`,
        sizes: "16x16",
        type: "image/png",
      },
    ],
    apple: [
      {
        url: `https://${CASINO_IMGIX}/bitcasino/images/livecasino/favicon/apple-touch-icon.png`,
        sizes: "180x180",
      },
    ],
    other: [
      {
        rel: "mask-icon",
        url: `https://${CASINO_IMGIX}/'bitcasino/images/livecasino/favicon/safari-pinned-tab.svg'`,
        color: "#DE0D3E",
      },
    ],
  },
  themeColor: "#DE0D3E",
  seo: {
    title: "general.title_livecasino",
    description: "general.meta_description_livecasino",
    og: {
      title: "og.title",
      description: "og.description",
      image: `https://${CASINO_IMGIX}/bitcasino/images/logo-livecasino.jpeg`,
    },
  },
};

export default livecasino;
